export const SessionType = {
    Simple: 'simple',
    RouterDownstream: 'router-downstream',
    RouterUpstream:  'router-upstream'
}